import produce from 'immer';

import {
  GET_AUTOMATIC_COLLECTION_LIST_FAILURE,
  GET_AUTOMATIC_COLLECTION_LIST_SUCCESS,
  GET_MANUAL_COLLECTION_LIST_FAILURE,
  GET_MANUAL_COLLECTION_LIST_SUCCESS,
} from '@actions/collection';

const initialState: ICollectionStore = {
  automaticCollectionList: null,
  manualCollectionList: null,
  error: null,
};

export default (state: ICollectionStore = initialState, action: any) =>
  produce(state, (draftState: ICollectionStore) => {
    switch (action.type) {
      case GET_AUTOMATIC_COLLECTION_LIST_SUCCESS:
        draftState.automaticCollectionList = action.response;
        draftState.error = null;

        return;

      case GET_AUTOMATIC_COLLECTION_LIST_FAILURE:
        draftState.error = action.error;

        return;

      case GET_MANUAL_COLLECTION_LIST_SUCCESS:
        draftState.manualCollectionList = action.response;
        draftState.error = null;

        return;

      case GET_MANUAL_COLLECTION_LIST_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
